import { gql, TypedDocumentNode } from "@apollo/client";

import { GitlabIntegration, QueryGitlabIntegrationArgs } from "types/generated";

export type GitLabIntegrationData = Pick<
  GitlabIntegration,
  | "id"
  | "name"
  | "description"
  | "apiHost"
  | "isDefault"
  | "userFacingHost"
  | "webhookUrl"
  | "webhookSecret"
  | "labels"
  | "space"
  | "vcsChecks"
  | "useGitCheckout"
>;

type GetVCSGitLabIntegrationQuery = {
  gitlabIntegration: GitLabIntegrationData;
};

export const GET_GITLAB_INTEGRATION: TypedDocumentNode<
  GetVCSGitLabIntegrationQuery,
  QueryGitlabIntegrationArgs
> = gql`
  query GetGitLabIntegration($id: ID!) {
    gitlabIntegration(id: $id) {
      useGitCheckout
      vcsChecks
      apiHost
      description
      id
      isDefault
      labels
      name
      space {
        id
        name
        accessLevel
      }
      userFacingHost
      webhookSecret
      webhookUrl
    }
  }
`;
